<div class="white-label__agency">
  <div class="white-label__agency-banner-wrap" *ngIf="!userSubscription?.isAgency && userSubscription?.boosterCategory !== UserSubscriptionCategory.AGENCY">
    <div class="white-label__agency-banner">
      <div class="white-label__agency-banner-texts">
        <div class="white-label__agency-banner-title">White Label is exclusive to Agency {{ userSubscription?.boosterProClient ? 'plan' : 'plans' }}</div>
        <div class="white-label__agency-banner-desc">Deliver a fully branded experience: customize the WordPress admin,<br/>launch client sites on your own domain, and auto-install plugins with every new site.</div>
      </div>
      <a class="ds-btn-purple-blue"  (click)="redirectPricing()">
        <i class="db-icon db-icon-ds-diamond-new mr8 mt2"></i>
        <span>Upgrade to Agency</span>
      </a>
    </div>
  </div>
  <div class="white-label__agency-title">White label</div>
  <div class="white-label-container-content">
    <div class="white-label-container-content-sidebar">
      <div *ngFor="let item of sidebarItems"
           class="white-label-container-content-sidebar-item"
           [class.active]="activeTab === item.routerLink"
           [routerLink]="item.routerLink"
           routerLinkActive="active">
        <h2>{{item.label}}</h2>
      </div>
    </div>
    <div class="white-label-container-content-main" [class.disabled]="!userSubscription?.isAgency && userSubscription?.boosterCategory !== UserSubscriptionCategory.AGENCY">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
